/* unplugin-vue-components disabled */import { render } from "./FormSalary.vue?vue&type=template&id=80b0470a&ts=true"
import script from "./FormSalary.vue?vue&type=script&lang=ts"
export * from "./FormSalary.vue?vue&type=script&lang=ts"

import "./FormSalary.vue?vue&type=style&index=0&id=80b0470a&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__